export const ZERO_PAGE = 0;
export const DEFAULT_PROJECTS_COUNT_PER_REQUEST = 12;

export const TIMEOUT_FOR_SSR_REQUEST = 1000;
export const TIMEOUT_FOR_BROWSER_REQUEST = 3000;